/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Submiterror1Inputs */

const he_contact_submiterror1 = /** @type {(inputs: Contact_Submiterror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אירעה שגיאה בשליחת ההודעה`)
};

const en_contact_submiterror1 = /** @type {(inputs: Contact_Submiterror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An error occurred while sending the message`)
};

/**
* | output |
* | --- |
* | "An error occurred while sending the message" |
*
* @param {Contact_Submiterror1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const contact_submiterror1 = /** @type {((inputs?: Contact_Submiterror1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Submiterror1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_contact_submiterror1(inputs)
	return en_contact_submiterror1(inputs)
});
export { contact_submiterror1 as "contact_submitError" }